import { BehaviorSubject, distinctUntilChanged, map, Observable } from "rxjs";

export const getToggleble = <
  T1 extends {
    [key in string]: object;
  },
>() => {
  const bs = new BehaviorSubject<{
    type: keyof T1;
    data: T1[keyof T1];
  } | null>(null);
  return {
    setState: <T extends keyof T1>(type: T, data: T1[T]) => {
      bs.next({
        type,
        data,
      });
    },
    getState$: <T extends keyof T1>(type: T) =>
      bs.pipe(
        // filter((t) => !t || t?.type === type),
        map((m) => (m?.type === type ? m?.data : null) as never),
        distinctUntilChanged(),
      ) as Observable<T1[T] | null>,
    resetState: () => bs.next(null),
  };
};
